import { FC, HTMLProps, ReactNode, useState } from 'react'
import classNames from 'classnames'
import Icon from 'project/Icon'

type CardProps = HTMLProps<HTMLDivElement> & {
  title?: string
  padding?: 'sm' | 'xs' | 'none'
  footer?: ReactNode
  footerClassName?: string
  collapsible?: boolean
  header?: ReactNode
  defaultExpanded?: boolean
}

const Card: FC<CardProps> = ({
  children,
  className,
  collapsible,
  defaultExpanded = true,
  footer,
  footerClassName,
  header,
  padding,
  title,
  ...rest
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  return (
    <div
      {...rest}
      className={classNames(
        'bg-card d-flex flex-column position-relative shadow-2 rounded-lg',
        'h-100',
        className,
      )}
    >
      <div
        className={classNames({
          'flex-1 d-flex flex-column h-100': true,
          'px-0 py-0': padding === 'none',
          'px-1 py-1': padding === 'xs',
          'px-2 py-2': padding === 'sm',
          'px-4 py-4': !padding,
        })}
      >
        {!!title && <h3>{title}</h3>}
        {collapsible && header ? (
          <>
            <div
              className='d-flex align-items-center cursor-pointer'
              onClick={() => setIsExpanded(!isExpanded)}
            >
              <div className='flex-fill'>{header}</div>
              <Icon
                name='chevron-down'
                fill='muted'
                className={`transition-transform ms-5 ${
                  isExpanded ? '' : 'rotate-180'
                }`}
              />
            </div>
            {isExpanded && (
              <>
                <hr className='my-4' />
                {children}
              </>
            )}
          </>
        ) : (
          children
        )}
      </div>

      {footer && (
        <div
          className={classNames(
            'card-footer',
            footerClassName,
            'rounded-bottom-lg',
            padding && `p-${padding}`,
          )}
        >
          {footer}
        </div>
      )}
    </div>
  )
}

export default Card
